import React, { useState,useEffect } from "react";
import "../../../styles/forgetPassword.css";
import userResetpwdlogo from "../../../assets/images/privacy.svg";
import pwclogo from "../../../assets/images/tata_motors_logo.png";
import displayToastMessage from "../Alert/displayToastMessage"
import { Input } from "@appkit4/react-components/field";
import eye from "../../../assets/images/eye.svg";
import closedeye from "../../../assets/images/icon-eye-closed.svg";
import {Button} from "@appkit4/react-components/button"
import PropTypes from "prop-types";
 import { useParams } from "react-router-dom/cjs/react-router-dom";
 import emailIcon from "../../../assets/images/emailIcon.svg";
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp";
import poweredByLogo from "../../../assets/images/poweredByLogo.png"

function ResetPassword(props) {
  const [validations] = useState("");
  const [isPassword, setIsPassword] = useState(true);
  const [isConfirmPassword, setIsConfirmPassword] = useState(true);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [errorEmailMessage, setErrorEmailMessage] = useState("");
  const [isErrorMessageShown, setIsErrorMessageShown] = useState(false);
  const [loginUser,setLoginUser]= useState(false);
  const [validationsMatched, setValidationsMatched] = useState(false);
  const param=useParams();
  const currentDateTime=()=>{
    let nowTime = new Date();
    // Get the year, month, and day  
const year = nowTime.getFullYear();  
const month = (nowTime.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based  
const day = nowTime.getDate().toString().padStart(2, '0');  
  
// Combine them into the desired format  
const todayFormatted = `${year}-${month}-${day}`;  
    const otpExpTime = new Date(`${todayFormatted}${`T`}${param.time}`);  
    var timeZoneDifference = nowTime.getTimezoneOffset();
    let millisec = nowTime.getTime() - otpExpTime.getTime();
    let minutes = millisec / 60000;
    minutes = minutes + timeZoneDifference;
    if(minutes>15){
      setTimeout(() => {
        props.history.push("/login");
      }, 2000);
    }
  }
  useEffect(() => {
    currentDateTime()
  }, []);
  const { sendRequest: resetNewPassword } = useHttp();
  const { sendRequest: resetNewPasswordEmailValidation } = useHttp();
  const [defaultValidationMessages] = useState([
    {
      isError: false,
      message: "At least 8 characters",
    },
    {
      isError: false,
      message: "At least one number",
    },
    {
      isError: false,
      message: "At least one special character (!,.-?%$...)",
    },
    {
      isError: false,
      message: "At least one capital letter",
    },
    {
      isError: false,
      message: "At least one small letter",
    },
    {
      isError: false,
      message: "Password not matched",
    },
  ]);
  const [
    validationMessagesTobeshown,
    setValidationMessagesTobeshown,
  ] = useState(defaultValidationMessages);
  const handlePassword = () => {
    const tempPassword = document.getElementById("field-input-reset-password-style")
    let tempType = tempPassword.getAttribute('type')
    if (tempType === 'password'){
      tempType = 'text'
    }
    else {
      tempType = 'password'
    }
    tempPassword.setAttribute('type', tempType)
  setIsPassword((prev) => !prev);
  };
  const handleConfirmPassword = () => {
    const tempPassword = document.getElementById("field-input-reset-confirm-password-style")
    let tempType = tempPassword.getAttribute('type')
    if (tempType === 'password'){
      tempType = 'text'
    }
    else {
      tempType = 'password'
    }
    tempPassword.setAttribute('type', tempType)
    setIsConfirmPassword((prev) => !prev);
  };
  const checkIfPasswordsMatch = (text, key) => {
    if (key === "password") {
      return (text === confirmPassword)
    }
    if (key === "confirm-password") {
      return (text === password)
    }
    return false;
  };

  const validate = (value, key) => {
    let res = [...defaultValidationMessages];
    if (value.length < 8) {
      res[0].isError = true;
    } else {
      res[0].isError = false;
    }

    if (value.search(/\d/) === -1) {
      res[1].isError = true;
    } else {
      res[1].isError = false;
    }

    if (value.search(/[^a-zA-Z0-9]/) === -1) {
      res[2].isError = true;
    } else {
      res[2].isError = false;
    }

    if (/([A-Z]+)/g.test(value)) {
      res[3].isError = false;
    } else {
      res[3].isError = true;
    }

    if (/([a-z]+)/g.test(value)) {
      res[4].isError = false;
    } else {
      res[4].isError = true;
    }

    if (key === "password") {
      const doesPasswordsMatch = checkIfPasswordsMatch(value, key);
      if (doesPasswordsMatch) {
        res[5].isError = false;
      } else {
        res[5].isError = true;
      }
    }
    if (key === "confirm-password") {
      const doesPasswordsMatch = checkIfPasswordsMatch(value, key);
      if (doesPasswordsMatch) {
        res[5].isError = false;
      } else {
        res[5].isError = true;
      }
    }
  };
  const handleLogin = () => {
    props.history.push("/login");
  };
  const checkAllConditionsSatisfy = () => {
    let matched = true;
    const newValidationMessages = [];
    for (let obj of defaultValidationMessages) {
      if (obj.isError) {
        matched = false;
        newValidationMessages.push(obj);
      }
    }
    setValidationMessagesTobeshown(newValidationMessages);
    setValidationsMatched(matched);
  };
  const handleChange = (value) => {
    validate(value, 'password');
    setPassword(value);
    checkAllConditionsSatisfy();
  };
  const handleEmailValue = (e) => {
    if (e || e === "") {
      setEmail(e);
      setErrorEmailMessage("");
    }
    else {
      setErrorEmailMessage("Special characters are not allowed");
    }
  };

  const handleConfirmPasswordChange = (value) => {
    validate(value, 'confirm-password');
    setConfirmPassword(value);
    checkAllConditionsSatisfy();
  };
  const handleSubmitEmail = async () => {
    let emailReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (email === "") {
      setErrorEmailMessage("Email id is required");
      setIsErrorMessageShown(true);
      return false;
    }
    if (emailReg.test(email) === false) {
      setErrorEmailMessage("Email id is not correct");
      setIsErrorMessageShown(true);
      return false;
    }
    const url = window.location.pathname;
        const splittedData = url.split("/");
        const obj = {
          encryptedData: splittedData[2],
          email: email,
          randomNumber:splittedData[4]
        };
        resetNewPasswordEmailValidation(APIService.resetNewPasswordEmailValidation(obj), (resetPasswordUser) => {
          if (resetPasswordUser.CODE) {
            setLoginUser(true);
          } else {
            setLoginUser(false);
            displayToastMessage("User is not authenticated", "error")
            setTimeout(() => {
              props.history.push("/login");
            }, 2000);
          }
        })
  }

  const responseHandler = (resetPassword) => {
    if (resetPassword.CODE) {
      displayToastMessage(resetPassword.MSG, "success")
      setTimeout(() => {
        props.history.push("/login");
      }, 2000);
    } else {
      displayToastMessage(resetPassword.MSG, "error")
    }
  }

  const handleSubmit = async () => {
    try {
      if (setValidationsMatched) {
        const url = window.location.pathname;
        const splittedData = url.split("/");
        const obj = {
          encryptedData: splittedData[2],
          newPassword: confirmPassword,
        };
        resetNewPassword(APIService.resetNewPassword(obj),
        responseHandler)
      }
    } catch (error) {
      console.log("Error",error)
      displayToastMessage(error.response.data.MSG, "error")
    }
  };

  return (
    <div className="loginBackground">
       <div className="container">
              <div className="row">
      <div className="row fixed-top login-bgm-alignment">
        <div className="ps-4">
          <img src={pwclogo}  alt="" height="80px"></img>
        </div>
        
      </div>

        
        <div className="col-lg-7 lf-div">
                  <h2 className="wt login-welcome">Welcome to the</h2>
                  <h3 className="login-tprm">Third Party Cybersecurity Assessment Programme </h3>
                  <p className="login-paragraph">
                  for Tata Motors Limited - A Web Based Assessment Questionnaire.
                  </p>
            </div>
            <div className="col-lg-1"></div>    
          <div className="col-lg-4 rgt-div loginBackgroundColor reset-passworddiv">
            <div className="my-1">
              <div className="card-body ">
                <div className="userlogo-style resetPassword">
                  <img src={userResetpwdlogo}  alt="new" />
                </div>
                {!loginUser?
                <div className="emailValidation">
                <Input
                    name="email"
                    id="userfield-style-email"
                    title="E-Mail"
                    type="text"
                    value={email}
                    onChange={handleEmailValue}
                    suffix={
                      <img
                      className="userIcon-style"
                      src={emailIcon}
                      alt="new"
                    />
                    }
                  />
                  <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorEmailMessage}
                </span>
              </div>
              <button
              type="submit"
              className="save-button loginCss  mt-3"
              onClick={handleSubmitEmail}
            >
              Next
            </button>
            </div>
:""}
            {loginUser? 
            <>
            <div className="form-label-group ">
                  <Input
                    name="password"
                    inputId="reset-password-style"
                    title="New Password"
                    type={isPassword ? "password" : "text"}
                    value={password}
                    onChange={handleChange}
                    suffix={
                      <img
                        className="userIcon-style"
                        src={isPassword ? eye : closedeye}
                        alt="new"
                        title={
                          isPassword
                            ? "Show Password"
                            : "Hide Password"
                        }
                        onClick={handlePassword}
                      />
                    }
                  />
                </div>
                <div className="form-label-group">
                  <Input
                    name="conformPassword"
                    inputId="reset-confirm-password-style"
                    title="Confirm Password"
                    type={isConfirmPassword ? "password" : "text"}
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                    suffix={
                      <img
                        className="userIcon-style"
                        src={isConfirmPassword ? eye : closedeye}
                        alt="new"
                        title={
                          isConfirmPassword
                            ? "Show Password"
                            : "Hide Password"
                        }
                        onClick={handleConfirmPassword}
                      />
                    }
                  />
                </div>

                {validations && (
                  <div className="form-label errorMsg">{validations}</div>
                )}

                {password.length > 0 ? (
                  <div className="form-label errorMsg">
                    {validationMessagesTobeshown?.map((item, index) => {
                        return <li key={index}>{item.message}</li>;
                      })}
                  </div>
                ) : (
                  ""
                )}
                {validationsMatched &&
                  confirmPassword.length &&
                  password.length > 0 ? (
                  <div className="form-label-group">
                    <Button
                      className="btnCss loginCss"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      <span>Submit</span>&nbsp;&nbsp;
                      <span className="icon-arrow-right-fill"></span>
                    </Button>
                    <div className="mt-3">
                      <span className="login-font-reset-password">Click here to </span>
                      <span className="forgotpwd-styles-fpwd" onClick={handleLogin}>
                        Login
                      </span>
                    </div>
                  </div>
                ) : null} 
                </>
                :""}
              </div>
            </div>
          </div>
          <div className="row">
               <div className="col-lg-10"></div>
               <div className="col-lg-2"> <img src={poweredByLogo} className="pwcPoweredByreset" alt=""></img>
               </div>
              
             </div>
    </div>
    </div>
    </div>
  );
}
ResetPassword.propTypes = {
  history: PropTypes.any
}
export default ResetPassword;
